import React from 'react';
import Container from '../components/sections/Container';

const Home = () => {

  return (
    <Container
    title = "Contact us"
    paragraph = "If you have any questions, suggestions, or feedback about Portacode, please feel free to drop us an email at support@portacode.com"
    >
    </Container>
  );
}

export default Home;